import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';
import {
  fetchAllApplicants,
  fetchApplicationYears,
  ExportToExcel,
  UpdatePersonalDetails,
} from "../adminApi";
import { PersonalDetailsDto } from "../../applicant/Models";
import { baseURL } from "../../../config/AxiosCall";
import { APPLICATION_STAGE } from "../../../common/models/enums/applicationStage";

export const fetchApplicationYearsThunk = createAsyncThunk(
  "applicants/fetchApplicationYears",
  async () => {
    let response: any;
    await fetchApplicationYears()
      .then((data) => {
        response = data;
      })
      .catch((error) => {
        response = error.response.data;
      });
    return response;
  }
);

export const fetchAllApplicantThunk = createAsyncThunk(
  "applicants/all",
  async (year: number) => {
    let response: any;
    await fetchAllApplicants(year)
      .then((data) => {
        response = data;
      })
      .catch((error) => {
        response = error.response.data;
      });
    return response;
  }
);

export const ExportToExcelThunk = createAsyncThunk(
  "exportToExcel",
  async ({ stage, year }: { stage: string | number; year?: number }, { rejectWithValue }) => {
    try {
      
      // Map the payload to the correct stage value for the backend
      let stageValue: number | string = stage;
      
      // Convert string stage names to their corresponding numeric values
      if (typeof stage === 'string') {
        const stageName = stage as keyof typeof APPLICATION_STAGE;
        if (stageName in APPLICATION_STAGE) {
          stageValue = APPLICATION_STAGE[stageName];
        }
      }
      
      // Ensure ApplicationFullyAssessedAndIsPendingUniversitySelection uses the correct value (12)
      if (stageValue === 'ApplicationFullyAssessedAndIsPendingUniversitySelection' || stageValue === 12) {
        stageValue = 12;
      }
      
      console.log('Exporting with stage:', stageValue, 'and year:', year);
      
      // Make the API call with both stage and year parameters
      const response = await axios({
        method: 'GET',
        url: `${baseURL}ApplicationManagement/export-to-excel?stage=${stageValue}&year=${year}`,
        responseType: 'blob',
        headers: {
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'Content-Type': 'application/json',
        },
      });
      
      // Handle the file download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      const timestamp = new Date().toISOString().split('T')[0];
      const filename = `applications-${timestamp}.xlsx`;
      
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      
      // Clean up
      if (link.parentNode) {
        link.parentNode.removeChild(link);
      }
      window.URL.revokeObjectURL(url);
      
      // Return a simple success message instead of the Blob
      return { success: true, message: 'Export completed successfully' };
    } catch (error: any) {
      console.error('Export failed:', error);
      // Return a simple error message
      return rejectWithValue({ 
        success: false, 
        message: error.response?.data?.message || 'Export failed. Please try again.' 
      });
    }
  }
);

export const UpdatePersonalDetailsThunk = createAsyncThunk(
  "UpdatePersonalDetails",
  async (payload: PersonalDetailsDto) => {
    let response: any;
    await UpdatePersonalDetails(payload)
      .then((data) => {
        response = data;
      })
      .catch((error) => {
        response = error.response.data;
      });
    return response;
  }
);